<template>
  <div id="OrgDetailTeam">
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title">企业团队</span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row" >
          <ul id="companyTeam">
            <li v-for="(user, index) in companyTeamList" :key="index">
              <div class="card">
                <div class="card-img-wrapper" @click="orgDetailTeamDialog(user.userId)" :data-userid="user.userId" :style="'background:url(' + getHeadImg(user) + ') no-repeat;background-size: contain;background-position: center center;cursor: pointer;'"></div>
                <div class="card-container">
                  <p><b>{{user.showName}}</b>{{user.userPhone}}</p>
                  <p>{{user.userEmail}}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';

export default {
  name: 'OrgDetailInfo',
  props: {
    companyTeamList: {
      type: Array
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  methods: {
    getHeadImg(user) {
      return user.headImg ? baseURL + user.headImg : baseURL + '/static/img/140x210.png';
    },
    orgDetailTeamDialog(showDetailUserId) {
      if (showDetailUserId === null || showDetailUserId === 'null' || showDetailUserId === '') {
        return;
      }
      eventBus.$emit('orgDetailTeamDialog', showDetailUserId);
    }
  }
};
</script>
<style scoped lang="less">
  ul, li {
    list-style: none;
  }
  #companyTeam{
    height: 280px;
    padding-left: 0px;
  }
  #companyTeam li{
    float:left;
    margin-right: 55px;
  }
  .card {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    width: 140px;
    /*border-radius: 5px;*/
  }
  .card:hover {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }
  .card-img-wrapper{
    width: 140px;
    height: 210px;
  }
  .card-container {
    /*padding: 2px 16px;*/
    text-align: center;
  }
  .card-container h6{
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .card-container p{
    font-size: 12px;
  }
</style>
